import {
  SearchResultCollection,
  SearchResultRepr,
} from '../borrowed/catalog/search/representations';

import { SearchResult } from '../borrowed/catalog-app/typescript/src/app/model/types';

import { User } from '../borrowed/sonder/rest/representations/identities/identities';

import { GetUsers } from './identities/access/identitiesServiceAccessorREST';
import { EntityRepr, EntityReprCollection } from '../borrowed/catalog/instance/representations';

export const DEFAULT_INSTANCE_RETRIEVAL_COUNT = 200;

//
// Catalog service TypeScript API calls
//

// Specifies information about a the response to a getDefinitionsInstance call
export interface SearchResultCollectionResponse {
  count: number;
  items: Array<SearchResult>;
  nextStart?: number; // nextStart is used in search but not in recent or favorites
  filtered?: boolean; // DSD+
}

export interface SearchRESTResponse extends SearchResultCollection {}

export interface SearchFavoritesRESTResponse extends Record<string, SearchResultRepr> {}

export interface EntityRESTResponse extends EntityRepr {}
export interface EntitiesRESTResponse extends EntityReprCollection {}

export type DataSource = SearchResult;

const knownUsers = new Map<string, User>();

// "SearchFavorites" is the unfortunate name of data sources that were identified by the folders
// service as recent or favorites and then presented to the catalog service to ensure they are
// applicable catalog results.  These are what are presented as collection items in the table.
export const getUsersFromSearchFavoritesResults = async (records: SearchFavoritesRESTResponse) => {
  const users = new Set<string>();
  for (const id in records) {
    const item = records[id];
    item?.owner && users.add(item.owner);
    item?.modifiedBy && users.add(item.modifiedBy);
  }

  return processUsers(users);
};

// "Search" is what it sounds like, actual results from searching.
export const getUsersFromSearchResults = async (items: SearchResultRepr[]) => {
  const users = new Set<string>();
  for (const item of items) {
    item?.owner && users.add(item.owner);
    item?.modifiedBy && users.add(item.modifiedBy);
  }

  return processUsers(users);
};

const processUsers = async (users: Set<string>) => {
  const unknownUserSet = new Set<string>();
  for (const user of users) {
    if (!knownUsers.get(user)) {
      unknownUserSet.add(user);
    }
  }

  if (unknownUserSet.size > 0) {
    const usersCollection = await GetUsers([...unknownUserSet]);
    const users = usersCollection.items;
    for (const user of users) {
      knownUsers.set(user.id, user);
    }
  }

  return knownUsers;
};
